import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=8f4d3920&scoped=true"
import script from "./photoList.vue?vue&type=script&lang=ts"
export * from "./photoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4d3920",
  null
  
)

export default component.exports